import { auth as adminAuth } from '../../admin-auth/adminAppAuth';
import { auth as mainAppAuth } from '../../../auth/appAuth';
import { apiRequest } from '../../../api/client';
import { getAdminApiToken } from '../../api/adminCall';
import { getLocalSessionToken } from '../../../api/authToken';
import {
  clearImpersonationSession,
  isImpersonationSessionActive,
  setImpersonationSession,
} from '../../../impersonation/utils/impersonationSession';

export const impersonateUser = async (userId, companyId) => {
  if (!adminAuth.currentUser) {
    throw new Error('Must be authenticated as an admin user');
  }

  const token = await getAdminApiToken();
  const result = await apiRequest('/api/admin/impersonation/start', {
    token,
    method: 'POST',
    body: { userId, companyId },
  });

  if (!result?.ticket) {
    throw new Error(result?.message || 'Failed to start impersonation');
  }

  setImpersonationSession({
    userId,
    companyId: companyId || result?.target?.companyId || null,
    adminUid: adminAuth.currentUser.uid,
    target: result.target || null,
  });

  return {
    success: true,
    ticket: result.ticket,
    sessionId: result.sessionId,
    claims: result.claims || null,
    target: result.target || {
      userId,
      companyId: companyId || null,
    },
  };
};

export const revokeImpersonationSession = async (userId, companyId, notes) => {
  const staffToken = getLocalSessionToken();
  if (!staffToken) return { success: true };

  try {
    await apiRequest('/api/auth/impersonation/end', {
      token: staffToken,
      method: 'POST',
      body: { userId, companyId, notes },
    });
  } catch (error) {
    console.error('End impersonation revoke failed:', error);
  }

  return { success: true };
};

export const signOutImpersonatedStaff = async () => {
  await mainAppAuth.signOut();
  clearImpersonationSession();
};

export const endImpersonation = async (userId, companyId, notes) => {
  await revokeImpersonationSession(userId, companyId, notes);
  await signOutImpersonatedStaff();
  return { success: true };
};

export const checkImpersonation = async () => isImpersonationSessionActive();
